(ns frontend.view.onboarding.terms-acceptance.view
  (:require
   [common.localization :as loc]
   [frontend.bootstrap.components :as rbs]
   [frontend.routing :as routing]
   [frontend.view.onboarding.components.common :as common]
   [frontend.view.onboarding.terms-acceptance.db :as db]
   [frontend.view.onboarding.terms-acceptance.events :as events]
   [ui.components.button.view :as button]))

(defn view
  []
  (let [{:keys [accepted?]} @db/state]
    [:div
     {:class-name "px-4 onboarding lose-padding-small"}
     [:div
      {:class-name "flex flex-col gap-4 h-full"}
      [:div
       {:class-name "onboarding onboarding__account-initialization"}
       [common/logo]
       [:div.card
        [:div.onboarding__info.text-center
         [:p
          (loc/tr :accept-terms-text-pre-tos)
          [:a
           {:href   "https://www.zapflow.com/terms-of-services"
            :target "_blank"}
           (loc/tr :accept-terms-text-link-tos)]
          (loc/tr :accept-terms-text-post-tos-pre-pp)
          [:a
           {:href   "https://www.zapflow.com/privacy-policy-new"
            :target "_blank"}
           (loc/tr :accept-terms-text-link-pp)]
          (loc/tr :accept-terms-text-post-pp-pre-gdpr)
          [:a
           {:href   "https://www.zapflow.com/data-processing-addendum"
            :target "_blank"}
           (loc/tr :accept-terms-text-link-gdpr)]
          (loc/tr :accept-terms-text-post-gdpr)]]
        [:div
         {:class-name "flex flex-col gap-4 onboarding-row-team-role mt-4 mb-2"}
         [:div
          {:class-name "flex justify-center"}
          [:label
           {:class-name "zap-inlined-checkbox-label"}
           [:input
            {:type       "checkbox"
             :class-name "zap-inlined-checkbox__green"
             :on-change  events/toggle-accept-terms
             :checked    (boolean accepted?)}]
           [:span {:class-name "checkmark"}]
           (loc/tr :accept-terms-checkbox-label-text)]]]
        [:div
         {:class-name "flex flex-col gap-4"}
         [:div
          {:class-name "onboarding__avatars-row"}]]
        [:div
         {:class-name "flex flex-col gap-4 onboarding__avatars-row"}
         [:div
          {:class-name "flex justify-center"}
          [button/primary-solid
           {:on-click  events/submit!
            :disabled? (not accepted?)}
           (loc/tr :accept-terms)]]]]]]]))

(defmethod routing/render-view :accept-terms
  []
  [view])
